<template>
  <div class="terminal-details">
    <enfold>
      <div class="td-title">
        <img src="@/assets/images/public/public_return.png" @click="$router.go(-1)" alt />
      </div>
      <div class="td-content">
        <div class="tc-left">
          <ul class="details-list">
            <li class="list-item" v-for="(val, key) in deviceKeyList" :key="key" v-show="key !== '音量' && key !== '亮度'">
              <div class="device-key">{{ key }} :</div>
              <!-- <div class="device-val">{{val | formatDeviceInfo}}</div> -->
              <div class="device-val">{{ val ? val : $t('cdcp38') }}</div>
            </li>
            <li class="list-item">
              <div class="device-key">音量 :</div>
              <div class="device-val">
                <div style="padding: 0px 16px;">
                  <el-slider @change="deviceCommandSet(deviceKeyList['音量'], 'voice')" v-model="deviceKeyList['音量']"
                    :show-tooltip="false"></el-slider>
                </div>
              </div>
            </li>
            <li class="list-item">
              <div class="device-key">亮度 :</div>
              <div class="device-val">
                <div style="padding: 0px 16px;">
                  <el-slider @change="deviceCommandSet(deviceKeyList['亮度'], 'bright')" v-model="deviceKeyList['亮度']"
                    :show-tooltip="false"></el-slider>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="tc-right">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="节目排期" name="pSchedule">
              <div class="p-pane p-tab-pane">
                <el-table :data="scheduleProgramMerge" style="width: 100%">
                  <el-table-column prop="name" label="节目名称"></el-table-column>
                  <el-table-column prop="level" label="指令等级" width="120"></el-table-column>
                  <el-table-column prop="timeArea" label="执行时间" width="120"></el-table-column>
                  <el-table-column prop="dateArea" label="有效日期" width="120"></el-table-column>
                  <el-table-column prop="validWeek" label="有效星期" width="120"></el-table-column>
                  <el-table-column prop="playCount" label="连播次数" width="100"></el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="节目列表" name="pList">
              <div class="p-pane p-tab-pane">
                <el-table :data="programList" style="width: 100%">
                  <el-table-column type="index" width="60" label="序号"></el-table-column>
                  <el-table-column prop="name" width="200" label="节目名称"></el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="截屏" name="pSnapshot">
              <div class="p-pane">
                <div class="screen-shot"></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="定时" name="pTiming">
              <div class="p-pane p-tab-pane">
                <el-table :data="settingSchedule" style="width: 100%">
                  <el-table-column type="index" label="序号" width="60"></el-table-column>
                  <el-table-column prop="action" label="操作指令" width="120">
                    <!-- <template slot-scope="scope">{{ scope.row.action | directive }}</template> -->
                    <template slot-scope="scope">{{ directive(scope.row.action)}}</template>
                  </el-table-column>
                  <el-table-column prop="value" label="值" width="120"></el-table-column>
                  <el-table-column prop="startTime" label="执行时间" width="240"></el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </enfold>
  </div>
</template>

<script>
import enfold from '@/components/basics/Enfold';
import { dateFormatting } from "@/assets/scripts/dateFormatting"; //, timeFormatting
import { daysWeek } from "@/assets/scripts/publicFunction";
const deviceKeyList = {
  "设备ID": "", "设备名称": "", "所属机构": "", "分辨率": "",
  "业务类型": "", "开屏时间": "", "关屏时间": "", "内存空间": "", "版本号": "",
  "运行状态": "", "连续运行": "", "盒子时钟": "", "IP地址": "", "最近心跳": "",
  "音量": 0, "亮度": 0
};

export default {
  name: "PandoraDetails",
  data() {
    return {
      deviceKeyList,
      activeName: 'pSchedule',
      tableData: [],
      deviceId: '',
      deviceSn: '',
      ksId: 0,
      deviceInfo: [],
      scheduleProgramMerge: [],
      programList: [],
      settingSchedule: []
    }
  },
  created() {
    // 通过路由获取id与sn
    this.deviceId = this.$route.params.id;
    this.deviceSn = this.$route.params.sn;
    this.ksId = this.$route.params.ks_id;
    // 当获取的ID或者SN为空时返回上一级路由页面
    this.deviceId || this.deviceSn ? this.initDeviceInfo() : this.$router.go(-1);
  },
  mounted() {
    this.$store.getters.myWebSocket.onmessage = (value) => {
      let info = JSON.parse(value.data);
      // 获取设备信息
      if (info.type === "get_device_info") {
        this.deviceKeyList["连续运行"] = info.data.status === 1 ? "在线&开屏&在播" : "离线";
        this.deviceKeyList["盒子时钟"] = dateFormatting(new Date(info.data.time));
        this.deviceKeyList["IP地址"] = info.data.device.remote_addr;
        this.deviceKeyList["内存空间"] = `${(info.data.device.usableSpace / 1024).toFixed(2)}G / ${(info.data.device.totalSpace / 1024).toFixed(2)}G`;
        this.deviceKeyList["音量"] = info.data.device.voice * 100;
        this.deviceKeyList["亮度"] = info.data.bright;
      }
      if (info.type === "get_schedule_program_merge") {
        this.scheduleProgramMerge = info.data;
        this.scheduleProgramMerge.forEach((item) => {
          item.timeArea = `${item.startTime} - ${item.endTime}`;
          item.isDateLimit
            ? item.dateArea = `${item.dateStart} - ${item.dateEnd}`
            : item.dateArea = "未设置日期";
          item.isWeekLimit
            ? item.validWeek = daysWeek(item.validWeek)
            : item.validWeek = '未设置星期';
        });
      }
      if (info.type === "get_program_list") {
        this.programList = info.data.data;
      }
      if (info.type === "get_setting_schedule") {
        this.settingSchedule = info.data;
      }
      console.log(info);
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    deviceCommandSet(value, command) {
      console.log(value, command);
      let msg = {
        role: 'web',
        from: 'device_command_set',
        data: {
          deviceInfo: {
            id: this.$route.params.id,
            sn: this.$route.params.sn,
            ks_id: this.$route.params.ks_id,
            token: this.$cookies.get("token")
          },
          requestCommand: command,
          value: parseFloat(value / 100)
        }
      };
      switch (command) {
        case 'voice':
          msg.data.value = parseFloat(value / 100);
          break;
        case 'bright':
          msg.data.value = parseInt(value);
          break;
      }
      this.$store.getters.myWebSocket.send(JSON.stringify(msg));
    },
    initDeviceInfo() {
      this.$http.post("/admin/device/detail", { id: this.deviceId }, data => {
        console.log(data);
        this.deviceKeyList["设备ID"] = data.id;
        this.deviceKeyList["设备名称"] = data.name;
        this.deviceKeyList["所属机构"] = data.group_name;
        this.deviceKeyList["分辨率"] = data.size_remark;
        // this.deviceKeyList["屏幕类型"] = data.type_remark;
        this.deviceKeyList["业务类型"] = data.attr_remark;
        let scheduleSetting = JSON.parse(data.schedule_setting);
        // 屏幕状态设置 start
        let open = scheduleSetting.findIndex((item) => item.action === 5);        // 开启屏幕
        let close = scheduleSetting.findIndex((item) => item.action === 4);        // 关闭屏幕
        this.deviceKeyList["开屏时间"] = open !== -1 ? `${scheduleSetting[open].dateStart}-${scheduleSetting[open].startTime}` : "未设置";
        this.deviceKeyList["关屏时间"] = close !== -1 ? `${scheduleSetting[close].dateStart}-${scheduleSetting[close].startTime}` : "未设置";
        // 屏幕状态设置 end
        this.deviceKeyList["版本号"] = data.system_version;
        this.deviceKeyList["运行状态"] = data.run_state === "1" ? "在线" : "离线";
        this.deviceKeyList["IP地址"] = data.remoteAddr;
        this.deviceKeyList["最近心跳"] = data.update_time;
      });
      this.getDeviceInfo();
      this.getScheduleProgramMerge();
      this.getProgramList();
      this.getSettingSchedule();
    },
    // 设备信息
    getDeviceInfo() {
      this.deviceInfo = this.deviceInfoHttp("get_device_info");
    },
    // 节目排期
    getScheduleProgramMerge() {
      this.scheduleProgramMerge = this.deviceInfoHttp("get_schedule_program_merge");
    },
    // 节目列表
    getProgramList() {
      this.programList = this.deviceInfoHttp("get_program_list");
    },
    // 定时
    getSettingSchedule() {
      this.settingSchedule = this.deviceInfoHttp("get_setting_schedule");
    },
    async deviceInfoHttp(type) {
      let msg = {
        type: "",
        id: this.deviceId,
        sn: this.deviceSn,
        groupName: `media_user_${this.$cookies.get('user_id')}`
      };
      msg.type = type;
      let result = null;
      await this.$http.post("/admin/websocket/sendToPandora", {
        device_sn: this.deviceSn,
        msg: encodeURIComponent(JSON.stringify([msg]))
      }, data => {
        result = data;
      });
      return result;
    },
    directive(val) {
      // return { "2": "亮度调节", "3": "音量调节", "4": "关闭屏幕", "5": "开启屏幕", }[val.toString()];
      switch (parseInt(val)) {
        case 2: return this.$t('cdcp39');
        case 3: return this.$t('cdcp40');
        case 4: return this.$t('cdcp41');
        case 5: return this.$t('cdcp42');
        default: return this.$t('cdcp43');
      }
    }
  },
  filters: {
    // formatDeviceInfo(val) {
    //   return val ? val : "设备离线-暂无数据";
    // },
    // directive(val) {
    //   // return { "2": "亮度调节", "3": "音量调节", "4": "关闭屏幕", "5": "开启屏幕", }[val.toString()];
    //   switch (parseInt(val)) {
    //     case 2: return "亮度调节";
    //     case 3: return "音量调节";
    //     case 4: return "关闭屏幕";
    //     case 5: return "开启屏幕";
    //     default: return "无状态"
    //   }
    // }
  },
  components: {
    enfold
  }
}
</script>

<style lang="scss" scoped>
.terminal-details {
  width: 100%;
  height: 100%;

  .td-title {
    height: 60px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    img {
      width: 30px;
      margin-left: 20px;
    }

    border-bottom: 2px solid #d7ecf3;
  }

  .td-content {
    height: calc(100% - 60px);
    // max-height: 620px;
    display: flex;
    // align-items: center;
    background: #edfbff;

    .tc-left {
      flex: 0 0 260px;
      padding: 12px 0px;
      border-radius: 0 8px 8px 0;
      background: #fff;

      .details-list {
        height: 100%;
        padding: 0px 12px;
        overflow-y: auto;

        .list-item {
          display: flex;
          font-size: 16px;

          .device-key {
            width: 74px;
            color: #606266;
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }

          .device-val {
            width: calc(100% - 80px);
            padding-left: 6px;
          }
        }

        .list-item+.list-item {
          margin-top: 16px;
        }
      }
    }

    .tc-right {
      flex: 1;
      margin-left: 12px;
      border-radius: 8px 0 0 8px;
      background: #fff;
      padding-left: 16px;

      /deep/ .el-tabs__header {
        margin: 0px;
      }

      .p-pane {
        height: calc(100vh - 60px - 62px - 24px - 48px - 15px);

        /deep/ .cell {
          font-size: 16px;
        }

        position: relative;

        .screen-shot {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 600px;
          height: 338px;
          background: #ccc;
        }
      }

      .p-tab-pane {
        overflow-y: auto;
      }

      /deep/.el-tabs__item {
        height: 48px;
        line-height: 48px;
        font-size: 16px;
      }
    }
  }
}
</style>
